import { HTMLAttributes } from 'react';

import { HeroWrapper } from './HeroWrapper';
import { HeroProvider } from './context';
import { IHero } from './types';

export function Hero(props: IHero & HTMLAttributes<HTMLElement>) {
  return (
    <HeroProvider>
      <HeroWrapper {...props} />
    </HeroProvider>
  );
}
